import React, { useContext, useRef, useState } from 'react';
import AuthContext from '../../context/AuthContext';

const buttonBase = {
  padding: '8px 16px',
  borderRadius: '4px',
  cursor: 'pointer',
};

const ImageZipUploader = () => {
  const { user, token } = useContext(AuthContext);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);
  const fileInputRef = useRef(null);

  const allowedEmails = [
    'sushantkrjha1@gmail.com',
    'harshita@ecombuddha.in',
    'bhavana@ecombuddha.in',
  ];
  const userEmail = (user && user.email) ? user.email.toLowerCase() : '';

  if (!user || !allowedEmails.includes(userEmail)) {
    return (
      <div style={{ padding: '24px' }}>
        <h2>Image ZIP to S3 URLs</h2>
        <p>You do not have access to this tool.</p>
      </div>
    );
  }

  const handleFileChange = (e) => {
    setFile(e.target.files[0] || null);
    setError('');
    setResult(null);
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a .zip file with images.');
      return;
    }

    if (!token) {
      setError('Missing auth token. Please re-login.');
      return;
    }

    setUploading(true);
    setError('');
    setResult(null);

    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
      const formData = new FormData();
      formData.append('zipFile', file);

      const resp = await fetch(`${API_URL}/image-zip-upload/upload`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await resp.json().catch(() => ({}));

      if (!resp.ok) {
        setError(data.error || 'Upload failed.');
        setUploading(false);
        return;
      }

      setResult(data);
    } catch (e) {
      setError('Unexpected error while uploading ZIP.');
    } finally {
      setUploading(false);
    }
  };

  const handleDownloadTxt = () => {
    if (!result || !Array.isArray(result.urls) || result.urls.length === 0) {
      return;
    }
    const blob = new Blob([result.urls.join('\n')], { type: 'text/plain;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const name = result.batch_id ? `image-urls-${result.batch_id}.txt` : 'image-urls.txt';
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleReset = () => {
    setFile(null);
    setError('');
    setResult(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div style={{ padding: '24px', maxWidth: '800px' }}>
      <h2>Image ZIP to S3 URLs</h2>
      <p>
        Upload a ZIP file containing images. Each image will be uploaded to
        <code> ecombuddha-application </code> bucket under folder <code> s3/zip-image-uploads/ </code> and you&apos;ll get back all S3 URLs.
      </p>

      <div style={{ marginTop: '16px', marginBottom: '16px' }}>
        <input
          ref={fileInputRef}
          type="file"
          accept=".zip"
          onChange={handleFileChange}
        />
      </div>

      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
        <button
          onClick={handleUpload}
          disabled={uploading || !file}
          style={{
            ...buttonBase,
            border: 'none',
            backgroundColor: '#175CAD',
            color: '#fff',
            cursor: uploading ? 'default' : 'pointer',
          }}
        >
          {uploading ? 'Uploading...' : 'Upload and Get S3 URLs'}
        </button>
        <button
          type="button"
          onClick={handleReset}
          disabled={uploading}
          style={{
            ...buttonBase,
            border: '1px solid #666',
            backgroundColor: '#fff',
            color: '#333',
          }}
        >
          Reset
        </button>
      </div>

      {error && (
        <div style={{ marginTop: '16px', color: '#d9534f' }}>
          {error}
        </div>
      )}

      {result && (
        <div style={{ marginTop: '24px' }}>
          <h3>Result</h3>
          <p>
            Bucket: <code>{result.bucket || 'ecombuddha-application'}</code>
          </p>
          <p>
            Folder: <code>{result.folder || 's3/zip-image-uploads'}</code>
          </p>
          <p>
            Batch ID: <code>{result.batch_id}</code>
          </p>
          <p>Total images uploaded: {result.count}</p>

          {Array.isArray(result.urls) && result.urls.length > 0 && (
            <>
              <div style={{ display: 'flex', gap: '12px', marginBottom: '12px', flexWrap: 'wrap' }}>
                <button
                  onClick={handleDownloadTxt}
                  style={{
                    ...buttonBase,
                    border: '1px solid #175CAD',
                    backgroundColor: '#fff',
                    color: '#175CAD',
                  }}
                >
                  Download URLs as .txt
                </button>
                <button
                  type="button"
                  onClick={handleReset}
                  style={{
                    ...buttonBase,
                    border: '1px solid #666',
                    backgroundColor: '#fff',
                    color: '#333',
                  }}
                >
                  Reset
                </button>
              </div>
              <textarea
                readOnly
                value={result.urls.join('\n')}
                style={{
                  width: '100%',
                  minHeight: '200px',
                  padding: '8px',
                  fontFamily: 'monospace',
                  fontSize: '12px',
                }}
              />
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ImageZipUploader;

